module.exports = __webpack_public_path__ + "img/qr-wx.22a2d5a.png";